<template>
  <div v-show="value" style="z-index: 2000" class="px-6 py-4 rounded-md flex items-center w-full" :class="config[type].bg_color">
    <font-awesome-icon :icon="config[type].icon" class=" w-5 h-5 sm:w-5 sm:h-5 mr-3" :class="config[type].icon_color"></font-awesome-icon>
    <span :class="config[type].text_color"> {{ message }} </span>
  </div>
</template>

<script>
export default {
  name: "alerts",
  props: {
    value: false,
    message: {
      type: String,
      default: 'Mensaje de alerta'
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data: () => ({
    config: {
      success: {
        text_color: 'text-green-800',
        bg_color: 'bg-green-200',
        icon_color: 'text-green-600',
        icon: 'check-circle'
      },
      danger: {
        text_color: 'text-red-500',
        bg_color: 'bg-red-100',
        icon_color: 'text-red-500',
        icon: 'exclamation-circle'
      },
      warning: {
        text_color: 'text-yellow-800',
        bg_color: 'bg-orange-50',
        icon_color: 'text-yellow-600',
        icon: 'exclamation-triangle'
      },
      primary: {
        text_color: 'text-blue-800',
        bg_color: 'bg-blue-200',
        icon_color: 'text-blue-600',
        icon: 'exclamation-circle'
      },
      default: {
        text_color: 'text-gray-800',
        bg_color: 'bg-gray-200',
        icon_color: 'text-gray-600',
        icon: 'exclamation-triangle'
      },
      info: {
        text_color: 'text-blue-600',
        bg_color: 'bg-blue-50',
        icon_color: 'text-blue-600',
        icon: 'exclamation-circle'
      }
    }
  }),
  mounted() {
  }
}
</script>

<style scoped>

</style>